import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import theme, { ThemeProviderRtl } from "./config/theme";
import { GlobalStyles } from "@mui/material";
import CustomToastContainer from "./components/ToastContainer";
import { AuthProvider } from "./store/auth-cxt";

import "react-toastify/dist/ReactToastify.css";
import "./assets/css/index.css";
import "./assets/css/fonts.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProviderRtl>
        <GlobalStyles
          styles={{
            body: {
              backgroundColor: theme.palette.background.default,
            },
          }}
        />
        <AuthProvider>
          <CustomToastContainer />
          <App />
        </AuthProvider>
      </ThemeProviderRtl>
    </BrowserRouter>
  </React.StrictMode>
);
